'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutAction = exports.authenticatingAction = exports.authenticatedAction = exports.authenticateFailureAction = undefined;

var _actionTypes = require('../actionTypes');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authenticateFailureAction = exports.authenticateFailureAction = function authenticateFailureAction() {
  return {
    type: _actionTypes2.default.AUTHENTICATE_FAILURE
  };
};

var authenticatedAction = exports.authenticatedAction = function authenticatedAction(user) {
  return {
    user: user,
    type: _actionTypes2.default.AUTHENTICATED
  };
};

var authenticatingAction = exports.authenticatingAction = function authenticatingAction() {
  return {
    type: _actionTypes2.default.AUTHENTICATING
  };
};

var logoutAction = exports.logoutAction = function logoutAction() {
  return {
    type: _actionTypes2.default.LOGOUT
  };
};